import React from 'react';
import clsx from 'clsx';

// Transparent-background product bottle renderer.
// Caller controls the size via tailwind class (e.g. "h-[28rem]") OR the `size` preset.
// `depth` (0-3) applies progressive blur+opacity to simulate background depth in stacks.
export default function Bottle({
  product,
  size = 'md',
  floating = false,
  depth = 0,
  className = '',
  priority = false,
}) {
  const sizePresets = {
    xs: 'h-24',
    sm: 'h-44',
    md: 'h-64',
    lg: 'h-[22rem]',
    xl: 'h-[30rem]',
    '2xl': 'h-[38rem]',
  };

  const depthStyles = [
    { filter: 'none',                     opacity: 1 },
    { filter: 'blur(0.5px) brightness(0.85)', opacity: 0.95 },
    { filter: 'blur(2px) brightness(0.7)',    opacity: 0.85 },
    { filter: 'blur(4px) brightness(0.55)',   opacity: 0.7 },
  ];

  return (
    <div
      className={clsx(
        'relative inline-flex items-end justify-center pointer-events-none',
        sizePresets[size] || sizePresets.md,
        floating && 'animate-float-slow',
        className
      )}
      data-testid={`bottle-${product.id}`}
    >
      <img
        src={product.image}
        alt={product.name}
        loading={priority ? 'eager' : 'lazy'}
        className="h-full w-auto object-contain select-none"
        draggable={false}
        style={{
          ...depthStyles[depth] || depthStyles[0],
          filter: `${depthStyles[depth]?.filter || ''} drop-shadow(0 30px 35px rgba(0,0,0,0.55))`,
        }}
        onError={(e) => { e.currentTarget.style.opacity = '0.2'; }}
      />
    </div>
  );
}
